import React, { Component } from 'react';
import {
  Modal,
  Row,
  Col,
  Typography,
  InputNumber,
  Button,
  message,
  Input,
  Spin,
} from 'antd';
import {
  DollarOutlined,
  CreditCardFilled,
  FileTextOutlined,
  BankOutlined,
  SwapOutlined,
  CloseOutlined
} from '@ant-design/icons';
import { connect } from 'react-redux';
import numeroALetra from '../../../Components/numeroALetra';
import axios from 'axios';
import ButtonItem from '../../../Components/ButtonItem';
import ticketPdf from '../../../Pdf/ticketPdf';
import pdfMake from "pdfmake/build/pdfmake";
import { MensajeError, dineroDisabledMask, round2Decimals  } from '../../../Components/Items';
import ModalBancos from '../ModalBancos/ModalBancos';
import qz from 'qz-tray';
import segundoTicketPdf from '../../../Pdf/segundoTicketPdf';
import ticketComplementoPdf from '../../../Pdf/ticketComplementoPdf';
import ticketCobroPdf from '../../../Pdf/ticketCobroPdf';
import printJS from 'print-js';

const { Title, Text } = Typography;

class ModalPago extends Component {
  state = {
    cashAmount: undefined,
    cardAmountCredit: undefined,
    cardAmountDebit: undefined,
    voucherAmount: undefined,
    checkAmount: undefined,
    transferAmount: undefined,
    bancosTarjeta: [],
    modalElegirBanco: false,
    reference: '',
    loading: false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.setState({ loading: false }); // Cambiado a false para que no aparezca loading al abrir
    }
  }

  handleConfirmPayment = async () => {

    if (round2Decimals(
      (this.state.cardAmountCredit || 0) +
      (this.state.cardAmountDebit || 0) +
      (this.state.voucherAmount || 0) +
      (this.state.checkAmount || 0) +
      (this.state.transferAmount || 0)) > this.props.totalPagar) {
      return message.warning("La suma de los pagos que no sean efectivo no puede ser mayor al total a pagar");
    }

    if (round2Decimals(this.state.cardAmountCredit + this.state.cardAmountDebit) === 0 || (this.state.cardAmountCredit === undefined && this.state.cardAmountDebit === undefined)) {
      return this.handleConfirmAll();
    }

    this.setState({ loading: true });
    const res = await axios.post(
      "puntoVenta/datosBancosTarjeta",
      {
        sesionId: this.props.sesionId,
        empresaId: this.props.empresaId,
      },
      { headers: this.props.headersToken }
    );

    if (res.data.success === 2) {
      if (res.data.bancosTarjeta && Array.isArray(res.data.bancosTarjeta)) {
        if (res.data.bancosTarjeta.length > 1) {
          this.setState({
            bancosTarjeta: res.data.bancosTarjeta,
            modalElegirBanco: true,
          });
        } else if (res.data.bancosTarjeta.length === 1) {
          // Si solo hay un banco, lo seleccionamos automáticamente
          this.handleConfirmAll(res.data.bancosTarjeta[0]._id);
        } else {
          this.setState({ loading: false });
          message.error("No se encontraron bancos y tarjetas disponibles");
        }
      } else {
        this.setState({ loading: false });
        message.error("No se encontraron bancos y tarjetas disponibles");
      }
    } else {
      this.setState({ loading: false });
      message.error(res.data.message || "No se pudo obtener la información de bancos y tarjetas");
    }
  }

  handleConfirmAll = async (bancoFinalTarjeta) => {

    if (this.props.cobroVenta) {
      this.procesarCobroVenta(bancoFinalTarjeta);
    } else {
      this.procesarVenta(bancoFinalTarjeta);
    }
  };

  procesarCobroVenta = async (bancoFinalTarjeta) => {

    if (this.state.modalElegirBanco) {
      this.setState({ modalElegirBanco: false, bancosTarjeta: [] });
    }

    const { cashAmount, cardAmountCredit, cardAmountDebit, voucherAmount, checkAmount, transferAmount, reference } = this.state;

    const { totalPagar, customer, onConfirmCobro, headersToken } = this.props;
    const totalPaid = round2Decimals((cashAmount || 0) + (cardAmountCredit || 0) + (cardAmountDebit || 0) + (voucherAmount || 0) + (checkAmount || 0) + (transferAmount || 0));
    const change = round2Decimals(totalPaid - totalPagar);


    const totalPagos = {
      efectivo: round2Decimals(cashAmount || 0),
      tarjetaCredito: round2Decimals(cardAmountCredit || 0),
      tarjetaDebito: round2Decimals(cardAmountDebit || 0),
      vales: round2Decimals(voucherAmount || 0),
      cheque: round2Decimals(checkAmount || 0),
      transferencia: round2Decimals(transferAmount || 0),
    };

    if (change > 0 && cashAmount > 0) {
      totalPagos.efectivo = round2Decimals((cashAmount || 0) - change);
    }

    if (totalPaid < totalPagar) {
      message.error('El monto pagado es insuficiente');
      return;
    }

    // Activar loading
    this.setState({ loading: true });

    try {
      // Actualizar totales sesión
      await axios.post(
        "puntoVenta/cobrarVenta",
        {
          fechaPago: new Date().toISOString(),
          sesionId: this.props.sesionId,
          bancoFinalTarjeta: bancoFinalTarjeta,
          clienteId: this.props.clienteId || null,
          vendedorId: headersToken.usuarioId,
          monedaId: "60c7e4396465ad440c41c15a",
          ventaId: this.props.ventaIdParaCobro,
          tipoDeCambioPago: 1,
          tipoDeCambioVenta: 1,
          bancoId: this.props.bancoId || null,
          totalPagos,
          empresaId: this.props.empresaId,
        },
        { headers: headersToken }
      ).then(async (res) => {
        if (res.data.success === 2) {
          message.success("Se ha cobrado una venta");
          if (res.data.respuestaComplemento?.empresa?.tikets && res.data.imprimirTicket) {
            this.printTicketCobro(res.data, !!res.data.respuestaComplemento?.data?.uuid);
          }


          onConfirmCobro({
            totalPagar,
            amountPaid: totalPaid,
            change,
            customer: customer || res.data.customer || 'Público en General',
            paymentDetails: {
              cash: cashAmount,
              cardCredito: cardAmountCredit,
              cardDebito: cardAmountDebit,
              voucher: voucherAmount,
              check: checkAmount,
              transfer: transferAmount,
            },
            reference,
          });

          this.setState({
            cashAmount: undefined,
            cardAmountCredit: undefined,
            cardAmountDebit: undefined,
            voucherAmount: undefined,
            checkAmount: undefined,
            transferAmount: undefined,
            reference: '',
            loading: false,
          });


        } else if (res.data.success === 1) {
          MensajeError({
            message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo cobrar la venta",
            description: res.data.errorTimbrado?.mensaje || res.data.description,
            detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
          });
          this.setState({ loading: false });
        } else {
          message.error("Hubo un error y la cobrar no se cobro");
          this.setState({ loading: false });
        }
      });



    } catch (error) {
      console.error('Error al procesar el pago:', error);
      message.error('Error al procesar el pago');
      this.setState({ loading: false });
    }
  };

  procesarVenta = async (bancoFinalTarjeta) => {

    if (this.state.modalElegirBanco) {
      this.setState({ modalElegirBanco: false, bancosTarjeta: [] });
    }

    const { cashAmount, cardAmountCredit, cardAmountDebit, voucherAmount, checkAmount, transferAmount, reference } = this.state;

    const { totalPagar, customer, onConfirm, headersToken } = this.props;
    const totalPaid = round2Decimals((cashAmount || 0) + (cardAmountCredit || 0) + (cardAmountDebit || 0) + (voucherAmount || 0) + (checkAmount || 0) + (transferAmount || 0));
    const change = round2Decimals(totalPaid - totalPagar);


    const totalPagos = {
      efectivo: round2Decimals(cashAmount || 0),
      tarjetaCredito: round2Decimals(cardAmountCredit || 0),
      tarjetaDebito: round2Decimals(cardAmountDebit || 0),
      vales: round2Decimals(voucherAmount || 0),
      cheque: round2Decimals(checkAmount || 0),
      transferencia: round2Decimals(transferAmount || 0),
    };

    if (change > 0 && cashAmount > 0) {
      totalPagos.efectivo = round2Decimals((cashAmount || 0) - change);
    }

    if (totalPaid < totalPagar) {
      message.error('El monto pagado es insuficiente');
      return;
    }

    // Activar loading
    this.setState({ loading: true });

    try {
      // Actualizar totales sesión
      await axios.post(
        "puntoVenta/agregarVenta",
        {
          sesionId: this.props.sesionId,
          factura: this.props.factura ? 1 : 2,
          fechaVenta: new Date().toISOString(),
          bancoFinalTarjeta: bancoFinalTarjeta,
          contado: 1,
          clienteId: this.props.clienteId || null,
          vendedorId: headersToken.usuarioId,
          monedaId: "60c7e4396465ad440c41c15a",
          tipoDeCambio: 1,
          cuentasXC: false,
          bancoId: this.props.bancoId || null,
          proyectoId: this.props.proyectoId,
          precioId: this.props.precioId,
          insumos: this.props.insumos || [],
          usoDeCfdiId: null,
          empresaId: this.props.empresaId,
          entregarInsumos: true,
          observaciones: this.props.observaciones || undefined,
          imprimirObservaciones: this.props.imprimirObservaciones || false,
          total: this.props.total,
          subtotal: this.props.subtotal,
          totalPagar: this.props.totalPagar,
          arrayImpuestos: this.props.arrayImpuestosVenta || [],
          arrayRetenciones: this.props.arrayRetencionesVenta || [],
          cuentasCliente: this.props.cuentasCliente || 0,
          totalPagos
        },
        { headers: headersToken }
      ).then(async (res) => {
        if (res.data.success === 2) {
          message.success("Se ha registrado una venta");
          if (res.data.respuestaFactura?.empresa?.tikets) {
            await this.printTicket(
              res.data,
              cashAmount,
              res.data.segundoTicket,
              res.data.respuestaFactura?.empresa,
              res.data?.respuestaFactura?.dataSat?.MetodoPago === "PPD"
            );
          }


          onConfirm({
            totalPagar,
            amountPaid: totalPaid,
            change,
            customer: customer || 'Público en General',
            paymentDetails: {
              cash: cashAmount,
              cardCredito: cardAmountCredit,
              cardDebito: cardAmountDebit,
              voucher: voucherAmount,
              check: checkAmount,
              transfer: transferAmount,
            },
            reference,
          });

          this.setState({
            cashAmount: undefined,
            cardAmountCredit: undefined,
            cardAmountDebit: undefined,
            voucherAmount: undefined,
            checkAmount: undefined,
            transferAmount: undefined,
            reference: '',
            loading: false,
          });


        } else if (res.data.success === 1) {
          MensajeError({
            message: res.data.errorTimbrado?.titulo || res.data.message || "No se pudo registrar la venta",
            description: res.data.errorTimbrado?.mensaje || res.data.description,
            detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
          });
          this.setState({ loading: false });
        } else {
          message.error("Hubo un error y la venta no se registro");
          this.setState({ loading: false });
        }
      });



    } catch (error) {
      console.error('Error al procesar el pago:', error);
      message.error('Error al procesar el pago');
      this.setState({ loading: false });
    }
  };

  printTicketCobro = async (dataTicket, complemento) => {
    try {

      if (!this.props.impresoraSeleccionada) {
        throw new Error("No hay impresora seleccionada");
      }

      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
      }

      const config = await qz.configs.create(this.props.impresoraSeleccionada ? this.props.impresoraSeleccionada : "",
        {
          encoding: 'Cp1252',
          scaleContent: false,     // No escalar el contenido del PDF
          rasterize: true,        // Evita convertir a imagen si no quieres que reduzca resolución
          density: 300             // Ajusta según tu impresora (203 o 300 dpi típico)
        }
      );


      // const data = ticketEscPos(dataTicket);
      let pdf2;
      if (complemento) {
        pdf2 = ticketComplementoPdf(dataTicket);
      } else {
        pdf2 = ticketCobroPdf(dataTicket);
      }
      const base64_1 = await new Promise((resolve) => {
        pdfMake.createPdf(pdf2).getBase64((base64) => resolve(base64));
      });

      await qz.print(config, [
        {
          type: 'pixel',
          format: 'pdf',
          flavor: 'base64',
          data: base64_1
        },
      ]);


      await qz.websocket.disconnect();
      // await qz.print(config, data);

    } catch (err) {
      console.error('Error imprimiendo ticket:', err);
      let pdf2;
      if (complemento) {
        pdf2 = ticketComplementoPdf(dataTicket);
      } else {
        pdf2 = ticketCobroPdf(dataTicket);
      }
      pdfMake.createPdf(pdf2).getBlob((blob) => {
        const pdfURL = URL.createObjectURL(blob);

        const ua = navigator.userAgent || "";
        const isAndroid = /Android/i.test(ua);

        // Chrome en iOS aparece como "CriOS"
        const isChromeiOS = /CriOS/i.test(ua);

        // WebView Android común (opcional pero útil)
        const isWebViewAndroid =
          isAndroid && /wv|Version\/\d+\.\d+.*Chrome\/\d+/i.test(ua);

        // ❌ Navegadores que NO pueden con printJS → visor directo
        if (isAndroid || isWebViewAndroid || isChromeiOS) {
          const win = window.open(pdfURL, "_blank");
          if (!win) window.location.href = pdfURL;
          setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
          return;
        }

        // ✅ Navegadores que SÍ pueden (o al menos vale la pena intentar)
        // Intentamos printJS y NO hacemos fallback si falla
        try {
          printJS({
            printable: pdfURL,
            type: "pdf",
            showModal: false,
          });
        } catch (e) {
          // Si falla de inmediato, NO hacemos nada más
          message.error("No se pudo imprimir el ticket automáticamente. Cambie de navegador (por ejemplo, Chrome o Firefox).");
          console.warn("printJS falló inmediatamente:", e);
        }

        // No revocar rápido o rompes printJS
        setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
      });
    }
  }

  printTicket = async (dataTicket, cashAmount, segundoTicket, empresa, contadoCredito) => {
    try {

      if (!this.props.impresoraSeleccionada) {
        throw new Error("No hay impresora seleccionada");
      }

      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
      }

      const config = await qz.configs.create(this.props.impresoraSeleccionada ? this.props.impresoraSeleccionada : "",
        {
          encoding: 'Cp1252',
          scaleContent: false,     // No escalar el contenido del PDF
          rasterize: true,        // Evita convertir a imagen si no quieres que reduzca resolución
          density: 300             // Ajusta según tu impresora (203 o 300 dpi típico)
        }
      );


      // const data = ticketEscPos(dataTicket);
      const pdf2 = ticketPdf(dataTicket);
      const base64_1 = await new Promise((resolve) => {
        pdfMake.createPdf(pdf2).getBase64((base64) => resolve(base64));
      });

      if (cashAmount > 0) {
        await qz.print(config, [
          {
            type: 'raw',
            format: 'hex',
            data: '1B700019FA'
          }
        ]);
      }

      let copias = 1;

      if (!contadoCredito && empresa?.impresionTicketsContado > 1) {
        copias = empresa?.impresionTicketsContado;
      }

      if (contadoCredito && empresa?.impresionTicketsCredito > 1) {
        copias = empresa?.impresionTicketsCredito;
      }

      for (let i = 1; i <= copias; i++) {
        await qz.print(config, [
          {
            type: 'pixel',
            format: 'pdf',
            flavor: 'base64',
            data: base64_1
          },
        ]);
      }


      if (segundoTicket) {
        const pdf3 = segundoTicketPdf(dataTicket);
        const base64_2 = await new Promise((resolve) => {
          pdfMake.createPdf(pdf3).getBase64((base64) => resolve(base64));
        });

        await qz.print(config, [
          {
            type: 'pixel',
            format: 'pdf',
            flavor: 'base64',
            data: base64_2
          },
        ]);
      }

      await qz.websocket.disconnect();
      // await qz.print(config, data);

    } catch (err) {
      console.error('Error imprimiendo ticket:', err);
      const pdf2 = ticketPdf(dataTicket);
      pdfMake.createPdf(pdf2).getBlob((blob) => {
        const pdfURL = URL.createObjectURL(blob);

        const ua = navigator.userAgent || "";
        const isAndroid = /Android/i.test(ua);

        // Chrome en iOS aparece como "CriOS"
        const isChromeiOS = /CriOS/i.test(ua);

        // WebView Android común (opcional pero útil)
        const isWebViewAndroid =
          isAndroid && /wv|Version\/\d+\.\d+.*Chrome\/\d+/i.test(ua);

        // ❌ Navegadores que NO pueden con printJS → visor directo
        if (isAndroid || isWebViewAndroid || isChromeiOS) {
          const win = window.open(pdfURL, "_blank");
          if (!win) window.location.href = pdfURL;
          setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
          return;
        }

        // ✅ Navegadores que SÍ pueden (o al menos vale la pena intentar)
        // Intentamos printJS y NO hacemos fallback si falla
        try {
          printJS({
            printable: pdfURL,
            type: "pdf",
            showModal: false,
          });
        } catch (e) {
          // Si falla de inmediato, NO hacemos nada más
          message.error("No se pudo imprimir el ticket automáticamente. Cambie de navegador (por ejemplo, Chrome o Firefox).");
          console.warn("printJS falló inmediatamente:", e);
        }

        // No revocar rápido o rompes printJS
        setTimeout(() => URL.revokeObjectURL(pdfURL), 60000);
      });
    }
  }

  handleCancel = () => {
    this.setState({
      cashAmount: undefined,
      cardAmountCredit: undefined,
      cardAmountDebit: undefined,
      voucherAmount: undefined,
      checkAmount: undefined,
      transferAmount: undefined,
      reference: '',
      loading: false,
    });
    this.props.onCancel();
  };

  render() {
    const { cashAmount, cardAmountCredit, cardAmountDebit, voucherAmount, checkAmount, transferAmount, reference, loading } = this.state;
    const { visible, totalPagar, /* customer, */ /* insumos = [] */ } = this.props;
    const totalPagarRound = round2Decimals(totalPagar);
    const totalPaid = round2Decimals((cashAmount || 0) + (cardAmountCredit || 0) + (cardAmountDebit || 0) + (voucherAmount || 0) + (checkAmount || 0) + (transferAmount || 0));
    const change = Math.max(0, totalPaid - totalPagarRound);
    const totalAlcanzado = round2Decimals(totalPaid - totalPagarRound) >= 0;

    return (
      <Modal
        title={null}
        visible={visible}
        onCancel={this.handleCancel}
        footer={null}
        width={900}
        centered
        closable={false}
        maskClosable={false}
        style={{ borderRadius: '8px' }}
        zIndex={2000}
      >
        <Spin spinning={loading} tip="Procesando pago...">
          <div style={{ padding: '10px', backgroundColor: '#f5f5f5', minHeight: '500px' }}>
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', backgroundColor: 'white', padding: '10px', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
              <Title level={3} style={{ margin: 0, color: '#1976d2' }}>Ticket {this.props.numeroVentaCobrar || ''}</Title>
              <Button type="text" icon={<CloseOutlined />} onClick={this.handleCancel} style={{ fontSize: '16px' }} disabled={loading} />
            </div>

            {/* {insumos.length > 0 && (
              <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: '20px', maxHeight: '200px', overflowY: 'auto' }}>
                <Title level={5} style={{ margin: '0 0 10px 0', color: '#1976d2' }}>Productos</Title>
                {insumos.map((producto, index) => (
                  <div key={index} style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '8px', marginBottom: '8px' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div style={{ flex: 1 }}>
                        <Text strong style={{ fontSize: '12px' }}>{producto.name}</Text>
                        <br />
                        <Text style={{ fontSize: '10px', color: '#666' }}>
                          {producto.cantidad} x {dineroDisabledMask(producto.precioUnitario.toFixed(2))}
                        </Text>
                        {producto.descuento > 0 && (
                          <Text style={{ fontSize: '10px', color: '#f44336', marginLeft: '10px' }}>
                            (-{producto.descuento}%)
                          </Text>
                        )}
                      </div>
                      <div style={{ textAlign: 'right', minWidth: '80px' }}>
                        <Text strong style={{ fontSize: '12px', color: '#1976d2' }}>
                          {dineroDisabledMask(producto.totalPagar.toFixed(2))}
                        </Text>
                        {producto.totalImpuestos >= 0 && (
                          <div style={{ fontSize: '10px', color: '#666' }}>
                            Imp: {dineroDisabledMask(producto.totalImpuestos)}
                          </div>
                        )}
                        {producto.totalRetenciones >= 0 && (
                          <div style={{ fontSize: '10px', color: '#f44336' }}>
                            Ret: -{dineroDisabledMask(producto.totalRetenciones)}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )} */}

            {/* Total a Pagar */}
            <div style={{ textAlign: 'center', marginBottom: '20px', backgroundColor: 'white', padding: '10px', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
              <Text style={{ fontSize: '14px', color: '#666' }}>Total a Pagar</Text>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
                <Title level={1} style={{ margin: 0, color: '#1976d2', fontSize: '48px' }}>
                  {dineroDisabledMask(totalPagarRound)}
                </Title>
                <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='16' viewBox='0 0 24 16'%3E%3Crect width='8' height='16' fill='%23006341'/%3E%3Crect x='8' width='8' height='16' fill='white'/%3E%3Crect x='16' width='8' height='16' fill='%23ce1126'/%3E%3C/svg%3E" alt="MX" style={{ width: '24px', height: '16px' }} />
              </div>
              <Text style={{ fontSize: '16px', color: '#666' }}>({numeroALetra(totalPagarRound, "MX")} PESOS MXN)</Text>
            </div>

            {/* Métodos de pago */}
            <div style={{ backgroundColor: 'white', padding: '25px', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', marginBottom: '20px' }}>
              <Row gutter={16}>
                {/* Efectivo */}
                <Col span={5}>
                  <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                    <div style={{ backgroundColor: '#4caf50', padding: '15px', borderRadius: '8px', marginBottom: '8px' }}>
                      <DollarOutlined style={{ fontSize: '24px', color: 'white' }} />
                    </div>
                    <Text style={{ fontSize: '12px', fontWeight: 'bold' }}>Efectivo</Text>
                  </div>
                  <InputNumber
                    min={0}
                    step={0.01}
                    value={cashAmount}
                    onChange={(v) => this.setState({ cashAmount: v || 0 })}
                    style={{ width: '100%' }}
                    disabled={loading}
                    autoFocus
                    placeholder='0.00'
                  />
                </Col>

                {/* Tarjeta */}
                <Col span={5}>
                  <div style={{ textAlign: 'center', marginBottom: '10px' }} onClick={() => {
                    if (totalPaid === 0) {
                      this.setState({
                        cardAmountDebit: totalPagarRound,
                      });
                    }
                  }}>
                    <div style={{ backgroundColor: '#2196f3', padding: '15px', borderRadius: '8px', marginBottom: '8px' }}>
                      <CreditCardFilled style={{ fontSize: '24px', color: 'white' }} />
                    </div>
                    <Text style={{ fontSize: '12px', fontWeight: 'bold' }}>Tarjeta Deb.</Text>
                  </div>
                  <InputNumber
                    min={0}
                    max={totalPagarRound}
                    step={0.01}
                    value={cardAmountDebit}
                    onChange={(v) => this.setState({ cardAmountDebit: v || 0 })}
                    style={{ width: '100%' }}
                    placeholder="0.00"
                    disabled={loading || (totalAlcanzado && (cardAmountDebit === 0 || cardAmountDebit === undefined))}
                  />
                </Col>

                <Col span={5}>
                  <div style={{ textAlign: 'center', marginBottom: '10px' }} onClick={() => {
                    if (totalPaid === 0) {
                      this.setState({
                        cardAmountCredit: totalPagarRound,
                      });
                    }
                  }}>
                    <div style={{ backgroundColor: '#2196f3', padding: '15px', borderRadius: '8px', marginBottom: '8px' }}>
                      <CreditCardFilled style={{ fontSize: '24px', color: 'white' }} />
                    </div>
                    <Text style={{ fontSize: '12px', fontWeight: 'bold' }}>Tarjeta Cred.</Text>
                  </div>
                  <InputNumber
                    min={0}
                    step={0.01}
                    max={totalPagarRound}
                    value={cardAmountCredit}
                    onChange={(v) => this.setState({ cardAmountCredit: v || 0 })}
                    style={{ width: '100%' }}
                    placeholder="0.00"
                    disabled={loading || (totalAlcanzado && (cardAmountCredit === 0 || cardAmountCredit === undefined))}
                  />
                </Col>

                {/* Vales */}
                <Col span={3}>
                  <div style={{ textAlign: 'center', marginBottom: '10px' }} onClick={() => {
                    if (totalPaid === 0) {
                      this.setState({
                        voucherAmount: totalPagarRound,
                      });
                    }
                  }}>
                    <div style={{ backgroundColor: '#ff9800', padding: '15px', borderRadius: '8px', marginBottom: '8px' }}>
                      <FileTextOutlined style={{ fontSize: '24px', color: 'white' }} />
                    </div>
                    <Text style={{ fontSize: '12px', fontWeight: 'bold' }}>Vales</Text>
                  </div>
                  <InputNumber
                    min={0}
                    step={0.01}
                    max={totalPagarRound}
                    value={voucherAmount}
                    onChange={(v) => this.setState({ voucherAmount: v || 0 })}
                    style={{ width: '100%' }}
                    placeholder="0.00"
                    disabled={loading || (totalAlcanzado && (voucherAmount === 0 || voucherAmount === undefined))}
                  />
                </Col>
                {/* Cheque */}
                <Col span={3}>
                  <div style={{ textAlign: 'center', marginBottom: '10px' }} onClick={() => {
                    if (totalPaid === 0) {
                      this.setState({
                        checkAmount: totalPagarRound,
                      });
                    }
                  }}>
                    <div style={{ backgroundColor: '#00bcd4', padding: '15px', borderRadius: '8px', marginBottom: '8px' }}>
                      <BankOutlined style={{ fontSize: '24px', color: 'white' }} />
                    </div>
                    <Text style={{ fontSize: '12px', fontWeight: 'bold' }}>Cheque</Text>
                  </div>
                  <InputNumber
                    min={0}
                    max={totalPagarRound}
                    step={0.01}
                    value={checkAmount}
                    onChange={(v) => this.setState({ checkAmount: v || 0 })}
                    style={{ width: '100%' }}
                    placeholder="0.00"
                    disabled={loading || (totalAlcanzado && (checkAmount === 0 || checkAmount === undefined))}
                  />
                </Col>

                {/* Transferencia */}
                <Col span={3}>
                  <div style={{ textAlign: 'center', marginBottom: '10px' }} onClick={() => {
                    if (totalPaid === 0) {
                      this.setState({
                        transferAmount: totalPagarRound,
                      });
                    }
                  }}>
                    <div style={{ backgroundColor: '#00b5e2', padding: '15px', borderRadius: '8px', marginBottom: '8px' }}>
                      <SwapOutlined style={{ fontSize: '24px', color: 'white' }} />
                    </div>
                    <Text style={{ fontSize: '12px', fontWeight: 'bold' }}>Transferencia</Text>
                  </div>
                  <InputNumber
                    min={0}
                    max={totalPagarRound}
                    step={0.01}
                    value={transferAmount}
                    onChange={(v) => this.setState({ transferAmount: v || 0 })}
                    style={{ width: '100%' }}
                    placeholder="0.00"
                    disabled={loading || (totalAlcanzado && (transferAmount === 0 || transferAmount === undefined))}
                  />
                </Col>
              </Row>


              {/* Referencia */}
              <div style={{ marginTop: '16px' }}>
                <Text style={{ fontSize: '12px', fontWeight: 'bold', color: '#4caf50' }}>🔗 Referencia:</Text>
                <Input
                  value={reference}
                  onChange={(e) => this.setState({ reference: e.target.value })}
                  placeholder="Ingrese referencia"
                  style={{ marginTop: '5px' }}
                />
              </div>
            </div>

            {/* Cliente y Cambio */}
            <Row gutter={16} style={{ marginBottom: '20px' }}>
              {/* <Col span={12}>
                <div style={{ backgroundColor: 'white', padding: '15px', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', height: '100%' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{ fontSize: '20px' }}>👤</div>
                    <div>
                      <Text style={{ fontSize: '12px', color: '#666' }}>{customer || 'Público en General'}</Text><br />
                      <Text style={{ fontSize: '12px', color: '#f44336' }}>Total a Crédito: $ 0.00</Text>
                    </div>
                  </div>
                  <div style={{ marginTop: '10px' }}>
                    <Text style={{ fontSize: '12px', color: '#666' }}>🏛️ Crédito</Text>
                  </div>
                </div>
              </Col> */}
              <Col span={24}>
                <div style={{ backgroundColor: 'white', padding: '15px', borderRadius: '6px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', height: '100%' }}>
                  <Text style={{ fontSize: '14px', color: '#666' }}>Cambio</Text>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Title level={2} style={{ margin: 0, color: '#4caf50', fontSize: '32px' }}>{dineroDisabledMask(change)}</Title>
                    <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='16' viewBox='0 0 24 16'%3E%3Crect width='8' height='16' fill='%23006341'/%3E%3Crect x='8' width='8' height='16' fill='white'/%3E%3Crect x='16' width='8' height='16' fill='%23ce1126'/%3E%3C/svg%3E" alt="MX" style={{ width: '24px', height: '16px' }} />
                  </div>
                  <Text style={{ fontSize: '12px', color: '#666' }}>{dineroDisabledMask(change)} MXN</Text>
                </div>
              </Col>
            </Row>

            {/* Botón */}
            <ButtonItem
              type="primary"
              size="large"
              onClick={this.handleConfirmPayment}
              disabled={totalPaid < totalPagarRound || loading}
              loading={loading}
              style={{
                width: '100%',
                height: '50px',
                backgroundColor: '#00b5e2',
                borderColor: '#00b5e2',
                fontSize: '16px',
                fontWeight: 'bold'
              }}
              icon={!loading && <span style={{ fontSize: '20px' }}>✓</span>}
            >
              {loading ? 'Procesando...' : 'Aceptar'}
            </ButtonItem>
          </div>
        </Spin>
        <ModalBancos
          visible={this.state.modalElegirBanco}
          onCancel={() => this.setState({ modalElegirBanco: false, loading: false })}
          onConfirmarBanco={this.handleConfirmAll}
          bancosTarjeta={this.state.bancosTarjeta}
        />
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(ModalPago);